import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=09caaa26&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=ts&"
export * from "./Calls.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./Calls.vue?vue&type=style&index=0&id=09caaa26&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "09caaa26",
  null
  ,true
)

export default component.exports